import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'navigation';
export const useNavigationTranslation = (): UseTranslationResponse<
  typeof ns
> => useTranslation(ns);

const reused = {
  latest_events: '$t(last_events)',
  event_archive: '$t(events_archive)',
  search: '$t(common:search)',
  checks: '$t(checks:page.title.checks)',
  queues: '$t(common:queues)',
  event_statistic: '$t(statistics)',
  faces: '$t(faces_title)',
  lists: '$t(lists_title)',
  fs_sources: '$t(event_sources)',
  handlers: '$t(handling_policies)',
  tasks: '$t(tasks_title)',
  accounts: '$t(users)',
  monitoring: '$t(common:monitoring)',
  features: '$t(common:features)',
  notifications: '$t(common:notifications)',
  vareporter_plans: '$t(plans)',
  vareporter_reports: '$t(reports)',
  verifiers: '$t(verification)',
  search_by_documents: '$t(common:search_by_documents)',
  departments: '$t(departments_title)',
  thermo: '$t(common:thermo)',
  plugins: '$t(plugins:title)',
};

export const ruRu = (__LOCALE_RU__ ? ({
  ...reused,
  events_and_video: 'События и видео',
  settings_and_catalogs: 'Настройки и справочники',
  administration: 'Администрирование',
  other: '',
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  ...reused,
  events_and_video: 'Events and Video',
  settings_and_catalogs: 'Settings and Catalogs',
  administration: 'Administration',
  other: '',
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  ...reused,
  events_and_video: 'Eventos y vídeo',
  settings_and_catalogs: 'Configuración y catálogos',
  administration: 'Administración',
  other: '',
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  ...reused,
  events_and_video: 'Eventos e Vídeos',
  settings_and_catalogs: 'Configurações e Catálogos',
  administration: 'Administração',
  other: '',
}) : {}) as Record<string, unknown>;
